<template>
    <div class="col-md-12">
        <form @submit.prevent="updateVehicle">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-3">
                        <div class="h2">#{{ vehicle.name }}</div>
                    </div>
                </div>
            </div>

            <div class="container-fluid bg-light py-3">
                <div class="controls">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="vehicle.name=='' && isSubmit? 'border-danger':''">
                                    <input type="text" autocomplete="none" required
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Vehicle name"
                                           v-model="vehicle.name">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>

                <div class="row">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-primary" @click="validation()">Save</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-muted"></p>
                    </div>
                </div>
            </div>

        </form>

        <br/>

        <a href="/vehicles" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>
    </div>
</template>
<script>
export default {
    name: "VehicleEdit",
    props: {
        url: {type: String, required: true}
    },
    data() {
        return {
            vehicle: {},
            isSubmit: false
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        updateVehicle() {
            axios.patch(`/vehicles/${this.vehicle.id}`, this.vehicle).then((response) => {
                window.location.href = '/drivers-and-companies';
            }).catch(err => console.log(err))
        },
        fetchData() {
            let dataFetchUrl = `${this.url}`
            axios.get(dataFetchUrl)
                .then(({data}) => {
                    this.vehicle = data;
                }).catch();
        },
    },
    created() {
        return this.fetchData()
    },
}
</script>
